/* global hcaptcha */
import { v as bvVar } from 'bv';
import BaseHCaptchaService from './base_hcaptcha_service';

const { hcaptcha: hcaptchaSettings } = bvVar('captchaSettings');

export default class InvisibleHCaptchaCaptchaService extends BaseHCaptchaService {
  isInvisibleHCaptcha = () => true;

  resolve = null;

  refresh = () => {
    const { siteKey } = hcaptchaSettings;
    this.widgetId = hcaptcha.render('hcaptcha', {
      sitekey: siteKey,
      size: 'invisible',
      callback: this.callback,
      'close-callback': this.closeCallback,
    });
  };

  execute = () => new Promise((resolve) => {
    if (this.widgetId) {
      hcaptcha.reset(this.widgetId);
    }
    this.resolve = resolve;
    hcaptcha.execute(this.widgetId);
  });

  callback = (token) => {
    this.resolve(token);
  };

  closeCallback = () => {
    this.resolve();
  };

  destroy = () => {
    hcaptcha.reset(this.widgetId);
    this.widgetId = '';
    this.resolve = null;
  };
}
